<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Chemical', apiMethod: 'Chemicals', form: () => import('../forms/ChemicalForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                ],
                tabs: [
                    { text: 'Purchases', value: 'chemicalId', table: () => import('../tables/ChemicalPurchasesTable') },
                ],
                mainForm: () => import('../forms/ChemicalForm'),
                claimName: 'Chemicals',
                apiMethod: 'Chemicals',
            }
        }
    };
</script>
